import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
  authService,
  IndividualRole,
  removeApiResponseInterceptor,
  useToast,
} from '@aslanpay/portal-common-lib';

const useSignOut = (role: IndividualRole | undefined = undefined) => {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation<unknown, Error>(() => authService.signOut(), {
    onSuccess: () => {
      removeApiResponseInterceptor();
      queryClient.resetQueries({ queryKey: ['getAuthenticatedUser'] });

      // TODO: Temporarily signing out when not signed in as an ASLAN_ADMIN
      if (role === 'COMPANY_ADMIN') {
        toast({
          position: 'top-right',
          status: 'error',
          title: 'Access denied',
          description: 'You cannot sign in on the backoffice portal as a Company Admin!',
        });
      }
    },
  });
};

export default useSignOut;
